<template>
  <div>
    <Header />
    <div id="screen-roles-manager" class="content-web container mt-5">
      <div class="row mb-5">
        <div class="col-12 col-sm-12 col-md-12 col-lg-5 mt-4 mt-md-5 mt-lg-0">
          <div class="table-custom card">
            <div class="table-custom title">
              <div class="row">
                <div class="col-6">
                  <h6>DANH SÁCH QUYỀN</h6>
                </div>
              </div>
            </div>
            <div class="list-grid col-12" v-if="loadingRole">
              <div class="text-center">
                <div class="spinner-border text-dark" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <div class="list-grid col-12">
              <div class="content-table">
                <table class="table table-hover table-md">
                  <thead>
                    <tr>
                      <th>Mã</th>
                      <th>Tên</th>
                      <th>Thao tác</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in dataRoles"
                      v-bind:key="index"
                      v-on:click="textSearch='';searchUserRoleByRoleCode(item.code, true)"
                    >
                      <td>{{ item.code}}</td>
                      <td>{{ item.name}}</td>
                      <td class="text-right">
                        <div class="dropdown">
                          <a
                            class="dropbtn dropdown-toggle"
                            href="#"
                            role="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >Hành động</a>
                          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a
                              class="dropdown-item"
                              href="javascript:void(0)"
                              v-on:click="fillDataToForm(item.code)"
                            >Thêm người dùng</a>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="row mt-4 pagination" v-if="totalPagesRole>1">
                <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pagesize">
                  <span
                    v-if="perPageRole*pageRole<totalDataRole"
                  >{{perPageRole*(pageRole-1)+1}}-{{perPageRole*pageRole}} of {{totalDataRole}}</span>
                  <span v-else>{{perPageRole*(pageRole-1)+1}}-{{totalDataRole}} of {{totalDataRole}}</span>
                </div>
                <div
                  class="col-lg-7 col-md-7 col-sm-7 col-xs-12 d-flex justify-content-end pageindex"
                >
                  <b-pagination
                    :total-rows="totalDataRole"
                    v-model="pageRole"
                    :per-page="perPageRole"
                    style="float: right"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-7 mt-4 mt-md-5 mt-lg-0">
          <div class="table-custom card">
            <div class="table-custom title">
              <h6>TÀI KHOẢN</h6>
            </div>
            <div class="table-custom pt-0" style="border-left: none; display: flex;">
              <input
                v-model="textSearch"
                class="form-control input-search"
                type="text"
                placeholder="Search By Account"
                v-on:keyup.enter="searchUserRole()"
              />
              <button
                v-on:click="searchUserRole(true)"
                type="button"
                class="btn sku-btn ml-2"
              >Tìm kiếm</button>
            </div>
            <div class="list-grid content-table col-12" v-if="loadingAccount">
              <div class="text-center">
                <div class="spinner-border text-dark" role="status">
                  <span class="sr-only">Đang tải...</span>
                </div>
              </div>
            </div>
            <div class="list-grid content-table col-12">
              <table class="table table-hover table-md">
                <thead>
                  <tr>
                    <th>Quyền</th>
                    <th>Cấp</th>
                    <th>Tài khoản</th>
                    <th>CTTV</th>
                    <th>Thao tác</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in dataRolesUser" v-bind:key="item.id">
                    <td>{{ item.roleCode}}</td>
                    <td>{{ item.companyCode ? 'CTTV' : 'Tập đoàn'}}</td>
                    <td>{{ item.account}}</td>
                    <td>{{ item.companyCode}}</td>
                    <td>
                      <button
                        v-on:click="moveIdtoModel(item.id)"
                        data-toggle="modal"
                        data-target="#deleteUserRoleModal"
                        class
                        style="font-size: 0.75rem; height: 30px;border: 1px solid #e7eaec;"
                      >Xóa</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="row mt-4 pagination" v-if="totalPages>1 && isDisplayPagingSearchCode">
                <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pagesize">
                  <span
                    v-if="perPage*pageSearchByCode<totalData"
                  >{{perPage*(pageSearchByCode-1)+1}}-{{perPage*pageSearchByCode}} of {{totalData}}</span>
                  <span v-else>{{perPage*(pageSearchByCode-1)+1}}-{{totalData}} of {{totalData}}</span>
                </div>
                <div
                  class="col-lg-7 col-md-7 col-sm-7 col-xs-12 d-flex justify-content-end pageindex"
                >
                  <!-- <b-pagination :total-rows="totalData" v-model="page" :per-page="perPage"  /> -->
                  <b-pagination
                    :total-rows="totalData"
                    v-model="pageSearchByCode"
                    :per-page="perPage"
                  />
                </div>
              </div>
              <div class="row mt-4 pagination" v-if="totalPages>1 && isDisplayPagingAccount">
                <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pagesize">
                  <span
                    v-if="perPage*page<totalData"
                  >{{perPage*(page-1)+1}}-{{perPage*page}} of {{totalData}}</span>
                  <span v-else>{{perPage*(page-1)+1}}-{{totalData}} of {{totalData}}</span>
                </div>
                <div
                  class="col-lg-7 col-md-7 col-sm-7 col-xs-12 d-flex justify-content-end pageindex"
                >
                  <b-pagination
                    :total-rows="totalData"
                    v-model="page"
                    :per-page="perPage"
                    style="float: right"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- addUserRoleModal start -->
    <b-modal ref="addUserRoleModal" size="md" hide-footer title="Thêm user">
      <validation-observer ref="formAddUserRole">
        <form>
          <div class="row mb-2">
            <div class="col-4">
              <label class="required">Quyền:</label>
            </div>
            <div class="col-8">
              <input
                type="text"
                v-model="rolesUserVO.roleCode"
                class="form-control input-user-role"
                readonly
              />
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-4">
              <label class="required">Tài khoản:</label>
            </div>
            <div class="col-8">
              <validation-provider :rules="{ required: true}" v-slot="validationContext">
                <b-form-input
                  type="text"
                  class="form-control"
                  v-model="rolesUserVO.account"
                  :state="getValidationState(validationContext)"
                ></b-form-input>
                <b-form-invalid-feedback id="input-name">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
            </div>
          </div>
          <div class="row mb-2" v-if="$cookies.get('globalRoles') === 'true'" >
            <div class="col-4">
              <label class="required">Công ty thành viên:</label>
            </div>
            <div class="col-8">
              <validation-provider :rules="{ required: true}" v-slot="validationContext">
                <b-form-select
                  v-model="rolesUserVO.companyCode"
                  :options="company"
                  value-field="code"
                  text-field="name"
                  :disabled="rolesUserVO.roleCode === 'initiative_council'"
                  :state="getValidationState(validationContext)"
                ></b-form-select>
                <b-form-invalid-feedback id="input-companyCode">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
            </div>
          </div>
        </form>
      </validation-observer>
      <div style="float: right;">
        <button
          v-on:click="hidenDivError()"
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
        >Đóng</button>
        <button
          v-on:click="addUserRole()"
          type="button"
          class="btn btn-success"
          style="background-color:#1ab394"
          id="btn-add-user-role"
        >Lưu</button>
      </div>
    </b-modal>

    <!-- AddUserRoleModal end -->

    <!-- modal delete User Role  start -->
    <div
      class="modal fade"
      id="deleteUserRoleModal"
      tabindex="-2"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteUserRoleModalLabel">Xóa người dùng</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">Bạn có muốn xóa người dùng này?</div>
          <div class="modal-footer">
            <button
              v-on:click="deleteUserRoleByID"
              type="button"
              class="btn btn-info"
              data-dismiss="modal"
            >OK</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Hủy</button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal delete User Role  end -->

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import Dropdown from "@/components/common/Dropdown.vue";
import departmentCommon from "../../common/department";
import employeeCommon from "../../common/employee";
import axios from "axios";
import helper from "../../common/helper";
import * as CONFIG from "../../config/index";
import roleCommon from "../../common/role";
import companyCommon from "../../common/company";
import userRoleCommon from "../../common/userRole";
import { BPagination } from "bootstrap-vue";

const rolesUserVODefault = {
  roleCode: "",
  roleTypeCode: null,
  account: "",
  companyCode: "null"
};

export default {
  name: "RolesManager",
  components: {
    Header,
    Footer,
    "b-pagination": BPagination
  },

  data() {
    return {
      dataRoles: [],

      dataRolesUser: [],

      dataUser: [],

      dataRoleType: [],

      depts: [],

      rolesUserVO: rolesUserVODefault,
      company: [],
      roleVO: {
        code: "",
        name: "",
        department: ""
      },

      textSearch: null,
      textSearchRole: null,

      idRoleOrUserRole: null,

      txtRoleTypeCode: "User",

      account: null,
      textTest: null,

      //paging user Roles -start

      page: 1,
      perPage: 10,
      totalPages: 0,
      totalData: 0,
      // paging user Roles-end

      //paging Roles -start

      pageRole: 1,
      perPageRole: 10,
      totalPagesRole: 0,
      totalDataRole: 0,
      // paging Roles-end
      editRoleId: "",
      editRoleCode: "",
      editRoleName: "",
      editRoleDepartment: "",

      editRoleVO: {
        id: "",
        code: "",
        name: "",
        department: ""
      },
      department: null,
      pageSearchByCode: 1,
      roleCode: "",
      isDisplayPagingSearchCode: true,
      isDisplayPagingAccount: false,
      deptCode: "",
      oldCode: "",
      roleCodeToDelete: "",
      loadingAccount: false,
      loadingRole: false
    };
  },
  async mounted() {
    // getRole
    this.getRolePage();
    // get user role
    this.getUserRole(true);
    this.company = [{ code: "null", name: "Tập đoàn" }];
    const listCompany = await companyCommon.getAll();
    listCompany.forEach(v => {
      this.company.push({ code: v.code, name: v.name });
    });
  },
  methods: {
    getUserRole: async function(isFirstPage = false, searchByRole = false) {
      this.loadingAccount = true;
      this.isDisplaypagingAccount = true;
      this.isDisplaypagingSearchCode = false;
      if (this.textSearch == null) {
        this.textSearch = "";
      }
      let roleCodeSearch = "";
      if (searchByRole === true) {
        roleCodeSearch = this.roleCode;
      }

      if (isFirstPage === true) {
        this.pageSearchByCode = 1;
      }
      let data = await userRoleCommon.search(
        this.textSearch,
        roleCodeSearch,
        this.pageSearchByCode,
        this.perPage
      );
      this.dataRolesUser = data.items;
      this.totalPages = Math.ceil(data.totals / this.perPage);
      this.totalData = data.totals;
      this.loadingAccount = false;
    },
    searchUserRole: function(reset) {
      if (reset) {
        this.page = 1;
        this.roleCode = "";
      }
      this.getUserRole(true, true);
    },
    searchUserRoleByRoleCode: function(idRoleCode, resetPage) {
      if (resetPage) {
        this.pageSearchByCode = 1;
      }
      this.isDisplayPagingAccount = false;
      this.isDisplayPagingSearchCode = true;
      if (idRoleCode != null) {
        this.roleCode = idRoleCode;
      }
      this.axios
        .get(
          `${CONFIG.API_URL}/user-role/searchByRole?roleCode=` +
            this.roleCode +
            `&account=&pageIndex=` +
            this.pageSearchByCode +
            `&pageSize=` +
            this.perPage
        )
        .then(resUserRoles => {
          this.dataRolesUser = resUserRoles.data.data.items;
          this.totalPages = Math.ceil(
            resUserRoles.data.data.totals / this.perPage
          );
          this.totalData = resUserRoles.data.data.totals;
        })
        .catch(e => {
          // this.error.push(e);
        });
    },
    moveIdtoModel: function(id, roleCodeToDelete) {
      this.roleCodeToDelete = roleCodeToDelete;
      this.idRoleOrUserRole = id;
    },
    getRolePage: async function() {
      this.loadingRole = true;
      if (this.textSearchRole == null) {
        this.textSearchRole = "";
      }
      let result = await roleCommon.search(
        this.textSearchRole,
        this.pageRole,
        this.perPageRole
      );
      this.dataRoles = result.items;
      this.totalPagesRole = Math.ceil(result.totals / this.perPageRole);
      this.totalDataRole = result.totals;
      this.loadingRole = false;
    },
    fillDataToForm: function(roleCode) {
      this.rolesUserVO = { ...rolesUserVODefault };
      this.rolesUserVO.roleCode = roleCode;
      this.$refs.addUserRoleModal.show();
    },
    async addUserRole(event) {
      const validate = await this.$refs.formAddUserRole.validate();
      if (!validate) {
        return;
      }

      const postData = { ...this.rolesUserVO };
      if (postData.companyCode === "null") {
        postData.companyCode = "";
      }

      this.axios
        .post(`${CONFIG.API_URL}/user-role`, postData)
        .then(resUserRoles => {
          this.account = "";
          helper.successMsg("Thêm người dùng thành công");
          this.getUserRole(true, true);
          this.$refs.addUserRoleModal.hide();
        })
        .catch(e => {
          helper.notifyError(e);
        });
    },
    deleteUserRoleByID: function() {
      let idUserRole = this.idRoleOrUserRole;
      this.axios
        .delete(`${CONFIG.API_URL}/user-role?id=` + idUserRole)
        .then(res => {
          this.getUserRole(true, true);
          helper.successMsg("Xóa người dùng thành công");
        })
        .catch(e => {
          helper.errMsg("Xóa người dùng thất bại");
        });
    },
    hidenDivError: function() {
      let divError = document.getElementsByClassName("error1");
      divError.forEach(element => {
        element.style.display = "none";
      });
      let divErrorEdit = document.getElementsByClassName("error2");
      divErrorEdit.forEach(element => {
        element.style.display = "none";
      });
      let selectUserInModel = document.getElementsByClassName("error3");
      selectUserInModel.forEach(element => {
        element.style.display = "none";
      });

      this.$refs.addUserRoleModal.hide();
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    searchUserRoleByRoleCode: function(idRoleCode, resetPage) {
      if (resetPage) {
        this.pageSearchByCode = 1;
      }
      this.isDisplayPagingAccount = false;
      this.isDisplayPagingSearchCode = true;
      if (idRoleCode != null) {
        this.roleCode = idRoleCode;
      }
      this.axios
        .get(
          `${CONFIG.API_URL}/user-role/search?roleCode=` +
            this.roleCode +
            `&account=&pageNo=` +
            this.pageSearchByCode +
            `&pageSize=` +
            this.perPage
        )
        .then(resUserRoles => {
          this.dataRolesUser = resUserRoles.data.data.items;
          this.totalPages = Math.ceil(
            resUserRoles.data.data.totals / this.perPage
          );
          this.totalData = resUserRoles.data.data.totals;
        })
        .catch(e => {
          // this.error.push(e);
        });
    }
  },
  watch: {
    page: {
      immediate: false,
      handler(newVal, oldVal) {
        this.getUserRole();
      }
    },
    pageSearchByCode: {
      immediate: false,
      handler(newVal, oldVal) {
        this.getUserRole();
      }
    },
    pageRole: {
      immediate: false,
      handler(newVal, oldVal) {
        this.getRolePage();
      }
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/table_customs.css";
@import "../../assets/css/dropdown_table_customs.css";

.header-table-roles .d-flex {
  align-items: center;
}

.header-table-roles .d-flex .button {
  display: flex;
  justify-content: flex-end;
}

#screen-roles-manager {
  margin-top: 20px;
}

.content {
  max-width: 1700px !important;
}

.modal-body form > .row {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: right;
}

.required:after {
  content: " * ";
  color: red;
}

.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid \9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}

div .errortemp {
  color: red;
  display: inline-block;
  margin-left: 5px;
}

div.modal-content {
  width: 600px;
}

.modal-body label {
  font-weight: 900;
}

.table-custom {
  padding: 20px 10px;
  background: #fff;
  width: 100%;
}

.table-custom .title {
  margin-top: 0;
  margin-left: -10px;
  margin-bottom: 20px;
  padding: 5px 0;
  border-left: 7px solid #3199bb;
  padding-left: 10px;
  font-weight: bold;
  color: grey;
}

.table-custom .title h6 {
  font-weight: 600;
  font-size: 16px;
}

.table-custom table {
  width: 100%;
  table-layout: fixed;
}

td {
  font-weight: 500;
  height: 68px !important;
}

.table-custom table th {
  border-bottom: solid 1px #e3e9f0;
  border-top: none;
  font-size: 12px !important;
  vertical-align: top;
  color: #898e97;
  font-weight: 500;
}
.input-search {
  width: 82%;
}
@media (max-width: 575.98px) {
  .input-search {
    width: 64%;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .input-search {
    width: 78%;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .input-search {
    width: 78%;
  }
}

@media (min-width: 1200px) {
  .input-search {
    width: 82%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/RolesManager.vue